import React, { useState } from "react";
import styles from "../FinanceDetailV2.module.scss";

const ACCENT_CLASSES = {
  red: styles.accentRed,
  orange: styles.accentOrange,
  blue: styles.accentBlue,
  gray: styles.accentGray,
  green: styles.accentGreen,
};

const ACCENT_ICON_COLORS = {
  red: "#fe5105",
  orange: "#ff8a00",
  blue: "#4463ff",
  green: "#28a745",
  gray: "#6c757d",
};

const AccordionSection = ({
  title,
  icon,
  accent = "gray",
  badge,
  headerExtra,
  defaultOpen = true,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div
      className={`${styles.accordionSection} ${ACCENT_CLASSES[accent] || ""}`}
    >
      <div
        className={styles.accordionHeader}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div className={styles.accordionHeaderLeft}>
          <span
            className={styles.accordionIcon}
            style={{ color: ACCENT_ICON_COLORS[accent] || ACCENT_ICON_COLORS.gray }}
          >
            <i className={`fa fa-${icon}`} />
          </span>
          <span className={styles.accordionTitle}>{title}</span>
          {badge != null && (
            <span className={styles.accordionBadge}>{badge}</span>
          )}
          {headerExtra && (
            <span className={styles.accordionHeaderExtra}>{headerExtra}</span>
          )}
        </div>
        <span
          className={`${styles.accordionChevron} ${isOpen ? styles.open : ""}`}
        >
          <i className="fa fa-chevron-down" />
        </span>
      </div>
      {/* Repli animé via grid-template-rows 0fr/1fr : suit les variations de
          hauteur du contenu (contrairement à un max-height figé). */}
      <div
        className={`${styles.accordionBody} ${isOpen ? styles.accordionBodyOpen : ""}`}
        aria-hidden={!isOpen}
      >
        <div className={styles.accordionBodyClip}>
          <div className={styles.accordionBodyInner}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AccordionSection;
